export default "__VITE_ASSET__ea4bf813__"